<div class="email-dialog">
  <div class="dialog-header">
    <h6>Send Request</h6>
    <button mat-icon-button class="close-icon" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="email-fields">
    <div class="field-container">
      <div class="field-label">
        <mat-label>To:</mat-label>
      </div>
      <div class="field-input">
        <mat-chip-grid #chipGrid>
          <mat-chip-row
            *ngFor="let email of selectedToEmails"
            (removed)="removeToEmail(email)"
          >
            {{ email }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
          <input
            type="text"
            placeholder="Add email"
            matInput
            [formControl]="to"
            [matAutocomplete]="autoTo"
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="addToEmail($event)"
          />
        </mat-chip-grid>
        <mat-autocomplete
          #autoTo="matAutocomplete"
          (optionSelected)="selectToEmail($event)"
        >
          <mat-option
            *ngFor="let option of filteredToOptions | async"
            [value]="option"
          >
            {{ option }}
          </mat-option>
        </mat-autocomplete>
        <div class="validation-message" *ngIf="selectedToEmails.length === 0">
          At least one recipient is required
        </div>
      </div>
    </div>

    <div class="field-container">
      <div class="field-label">
        <mat-label>CC:</mat-label>
      </div>

      <div class="field-input">
        <mat-chip-grid #chipGridCc>
          <!-- Static CC email -->
          <mat-chip-row
            *ngFor="let email of selectedCcEmails"
            [removable]="false"
          >
            {{ email }}
          </mat-chip-row>
        </mat-chip-grid>

        <!-- No input/autocomplete for CC -->

        <div class="static-cc-message" *ngIf="isCcLocked">
          <mat-icon>lock</mat-icon>
          This CC address is fixed and cannot be changed.
        </div>
      </div>
    </div>

    <div class="field-container-sig">
      <div class="field-label-sig">
        <mat-label>Signature:</mat-label>
      </div>
      <div class="field-container-input">
        <div class="field-input">
          <mat-form-field appearance="outline">
            <textarea
              matInput
              placeholder="Enter Signature"
              cdkTextareaAutosize
              [formControl]="email_signature"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="checkbox-container">
          <mat-checkbox [formControl]="update_signature"
            >Update Signature</mat-checkbox
          >
        </div>
      </div>
    </div>
  </div>

  <div class="button-section">
    <button mat-flat-button class="cancel-button" (click)="closeDialog()">
      Cancel
    </button>
    <button
      mat-flat-button
      class="continue-button"
      [disabled]="
        selectedToEmails.length === 0 || selectedCcEmails.length === 0
      "
      (click)="onContinue()"
    >
      Continue
    </button>
  </div>
</div>
